module.exports = __webpack_public_path__ + "img/members.f6a0f25d.svg";